module.exports = __webpack_public_path__ + "static/media/henri-jaaskelainen.c6934094.jpg";